import { render, staticRenderFns } from "./Escolaridade.vue?vue&type=template&id=8ccad130"
import script from "./Escolaridade.vue?vue&type=script&lang=js"
export * from "./Escolaridade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports